module.exports = __webpack_public_path__ + "img/event-view-007.a5629709.png";